import type {
  EolSectionTypeValue,
  PlaceOfCareSnomedCode
} from '@lmc/validations'
import { PlaceOfCareSnomedDescriptionEnum as SnomedDescriptions } from '@lmc/validations'

export type {
  EolSectionTypeValue,
  PlaceOfCareSnomedCode
} from '@lmc/validations'
export {
  EolSectionType,
  EolSectionTypeValues,
  PlaceOfCareSnomedDescriptionEnum,
  PlaceOfCareSnomedEnum,
  PlaceOfCareSnomedEnumValues
} from '@lmc/validations'

export const placeOfCareOptions = (
  Object.entries(SnomedDescriptions) as [PlaceOfCareSnomedCode, string][]
).map(([value, label]) => ({ value, label }))

export type EolEntry = Record<string, string | undefined>

export interface EolStructuredSection {
  sectionType: EolSectionTypeValue
  label: string
  entries: EolEntry[]
}
